import React from 'react'
import Card from '#app/components/cards/card.tsx'

const ExampleCard = () => {
	return (
		// <div className="mt-4 flex items-center justify-center p-4 max-w-5xl mx-auto">
		<div className="mt-4 flex items-center justify-center p-4">
			<Card title="Team Summary" description="This is a description of the team summary card.">
				<Card.Actions>
					<button className="rounded-md bg-neutral-900 px-2 py-1 text-sm text-white transition hover:bg-neutral-800">Add</button>
					<button className="rounded-md bg-gray-200 px-2 py-1 text-sm text-gray-800 transition hover:bg-gray-300">Export</button>
					<button className="rounded-md bg-red-500 px-2 py-1 text-sm text-white transition hover:bg-red-600">Delete</button>
				</Card.Actions>

				<Card.Errors>
					<div><span>Add errors here if necessary</span></div>
				</Card.Errors>

				<p className="text-sm">This card shows a clean, responsive layout where buttons wrap into multiple lines on smaller screens.</p>

				<Card.Footer title="Last updated">
					<span>Last updated: Oct 10, 2025</span>
				</Card.Footer>
			</Card>
		</div>
	)
}

export default ExampleCard
